// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3314":"css/admin-app.6669","9462":"css/app.6669"}[chunkId] + ".css";
};